import React, {useState, useEffect, useCallback} from 'react';
import {Box, createTheme, useMediaQuery, ThemeProvider} from '@mui/material';
import Cookies from 'js-cookie';
import {
  AddCircleIcon,
  IconDelete,
  IconDownload,
  IconProfile,
  IconRename,
  macWP,
} from '../../assets';
import {Language} from '../../context/LanguageContext';
import {
  ModalFlexible,
  UploadDataCenterCard,
  PageNav,
  ProgramKerjaCard,
  UserAccessCard,
} from '../../components';
import {Search} from '@material-ui/icons';
import {useUser} from '../../hooks';
import {UPLOAD_DATA_CENTER_TAB_LIST} from '../../consts/common';
import {useNavigate} from 'react-router-dom';
import '../../assets/styles/userListV2.scss';

export default function UploadDataCenter({type}) {
  const [payload, setPayload] = useState({
    tab: UPLOAD_DATA_CENTER_TAB_LIST[type][0]?.value,
    q: '',
  });
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const {language, newObj} = Language();
  const tokens_session = Cookies.get('token');
  const {
    getProgramKerjaList,
    getSyorList,
    deleteSyor,
    updateSyor,
    downloadSyor,
    getAtdList,
    updateAtd,
    deleteAtd,
    downloadAtd,
    getPPPLSList,
    updatePPPLS,
    deletePPPLS,
    downloadPPPLS,
    getApplicationAuthorizationList,
    getPesertaDanLotList,
    deletePesertaDanLot,
    downloadPesertaDanLot,
    getKewanganList,
    updateKewangan,
    deleteKewangan,
    downloadKewangan,
  } = useUser();
  const [userAccessList, setUserAccessList] = useState([]);
  const tabList = UPLOAD_DATA_CENTER_TAB_LIST[type];
  const [selected, setSelected] = useState(null);
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'],
    },
  });
  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const handleAddButton = (type) => {
    switch (type) {
      case 'programKerja':
        setModalType('programKerja');
        setSelected({
          type: 'add',
        });
        break;
      case 'pengesyoranBaja':
        navigate('/upload-pengesyoran-baja');
        break;
      case 'atd':
        navigate('/upload-atd');
        break;
      case 'pppls':
        navigate('/upload-pppls');
        break;
      case 'applicationAuthorization':
        setModalType('appAuth');
        setSelected({
          type: 'add',
        });
        break;
      case 'participantAndLot':
        navigate('/upload-participants-and-lot');
        break;
      case 'finance':
        navigate('/upload-finance');
        break;
      default:
        break;
    }
    setOpenModal(true);
  };
  const addButtonText = (type) => {
    switch (type) {
      case 'programKerja':
        return newObj.AddProgramKerjaWord[language];
      case 'pengesyoranBaja':
      case 'atd':
      case 'pppls':
      case 'participantAndLot':
      case 'finance':
        return newObj.UploadDataWord[language];
      case 'applicationAuthorization':
        return newObj.AddUserWord[language];
      default:
        return '';
    }
  };
  const uploadDataCenterCardProps = (type, item) => {
    const ext = item?.key?.split('.')[item?.key?.split('.').length - 1];
    switch (type) {
      case 'programKerja':
        return {
          text: item.jenisKerja,
          code: item.kodActiviti,
          jenisKerja: item.jenisKerja,
          jenisTanaman: item.jenisTanaman,
          options: [
            {
              text: newObj.RenameWord[language],
              onClick: () => {},
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {},
            },
          ],
          onClick: () => {
            setModalType('programKerja');
            setSelected({
              type: 'edit',
              ...item,
            });
            setOpenModal(true);
          },
        };
      case 'pengesyoranBaja':
        return {
          text: item.name,
          options: [
            {
              text: newObj.DownloadWord[language],
              onClick: async () => {
                const response = await downloadSyor(tokens_session, {
                  filename: item.key,
                });
                const uint8Array = new Uint8Array(response.data);
                const blob = new Blob([uint8Array], {
                  type: `application/vnd.ms-excel`,
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('target', '_blank');
                a.setAttribute('download', item.key);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              },
              icon: IconDownload,
            },
            {
              text: newObj.RenameWord[language],
              onClick: () => {
                setModalType('rename');
                setOpenModal(true);
                setSelected({
                  title: newObj.RenameWord[language],
                  onClose: () => setOpenModal(false),
                  onSubmit: async (name) => {
                    await updateSyor(tokens_session, {
                      id: item.guid,
                      name,
                    });
                    await handleGetDataList(tokens_session, payload);
                  },
                });
              },
              icon: IconRename,
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this?',
                  onClose: () => setOpenModal(false),
                  onSubmit: () => {
                    deleteSyor(tokens_session, {
                      id: item.id,
                    });
                    handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },

              icon: IconDelete,
            },
          ],
        };
      case 'atd':
        return {
          text: item.name,
          options: [
            {
              text: newObj.DownloadWord[language],
              icon: IconDownload,
              onClick: async () => {
                const response = await downloadAtd(tokens_session, {
                  filename: item.key,
                });
                const uint8Array = new Uint8Array(response.data);
                const blob = new Blob([uint8Array], {
                  type: `application/vnd.ms-excel`,
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('target', '_blank');
                a.setAttribute('download', item.key);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              },
            },
            {
              text: newObj.RenameWord[language],
              onClick: () => {
                setModalType('rename');
                setOpenModal(true);
                setSelected({
                  title: newObj.RenameWord[language],
                  onClose: () => setOpenModal(false),
                  onSubmit: async (name) => {
                    await updateAtd(tokens_session, {
                      id: item.guid,
                      name,
                    });
                    await handleGetDataList(tokens_session, payload);
                  },
                });
              },
              icon: IconRename,
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this?',
                  onClose: () => setOpenModal(false),
                  onSubmit: () => {
                    deleteAtd(tokens_session, {
                      id: item.id,
                    });
                    handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },
              icon: IconDelete,
            },
          ],
        };
      case 'pppls':
        return {
          text: item.name,
          ext,
          options: [
            {
              text: newObj.DownloadWord[language],
              icon: IconDownload,
              onClick: async () => {
                const response = await downloadPPPLS(tokens_session, {
                  filename: item.key,
                });
                const uint8Array = new Uint8Array(response.data);
                const blob = new Blob([uint8Array], {
                  type: `application/vnd.ms-excel`,
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('target', '_blank');
                a.setAttribute('download', item.key);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              },
            },
            {
              text: newObj.RenameWord[language],
              onClick: () => {
                setModalType('rename');
                setOpenModal(true);
                setSelected({
                  title: newObj.RenameWord[language],
                  onClose: () => setOpenModal(false),
                  onSubmit: async (name) => {
                    await updatePPPLS(tokens_session, {
                      id: item.guid,
                      name,
                    });
                    await handleGetDataList(tokens_session, payload);
                  },
                });
              },
              icon: IconRename,
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this?',
                  onClose: () => setOpenModal(false),
                  onSubmit: async () => {
                    await deletePPPLS(tokens_session, {
                      id: item.guid,
                    });
                    await handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },
              icon: IconDelete,
            },
          ],
          onClick: () => {
            // setModalType('pppls');
            // setSelected({
            //   type: 'edit',
            //   id: item.id,
            //   name: item.name,
            //   description: item.description,
            //   status: item.status,
            // });
            // setOpenModal(true);
          },
        };
      case 'applicationAuthorization':
        return {
          textUpper: item.firstname + ' ' + item.lastname,
          textLower: item.username,
          avatar: item.avatar || IconProfile,
          onClick: () => {
            setModalType('appAuth');
            setSelected({
              type: 'edit',
              ...item,
            });
            setOpenModal(true);
          },
        };
      case 'participantAndLot':
        return {
          text: item.name,
          ext,
          options: [
            {
              text: newObj.DownloadWord[language],
              icon: IconDownload,
              onClick: async () => {
                const response = await downloadPesertaDanLot(tokens_session, {
                  filename: item.key,
                });
                const uint8Array = new Uint8Array(response.data);
                const blob = new Blob([uint8Array], {
                  type: `application/vnd.ms-excel`,
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('target', '_blank');
                a.setAttribute('download', item.key);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              },
            },
            {
              text: newObj.DeleteWord[language],
              icon: IconDelete,
              onClick: async () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this?',
                  onClose: () => setOpenModal(false),
                  onSubmit: async () => {
                    await deletePesertaDanLot(tokens_session, {
                      key: item.key,
                    });
                    await handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },
            },
          ],
          onClick: () => {
            // setModalType('participantAndLot');
            // setSelected({
            //   type: 'edit',
            //   id: item.id,
            //   name: item.name,
            //   description: item.description,
            //   status: item.status,
            // });
            // setOpenModal(true);
          },
        };
      case 'finance':
        return {
          text: item.name,
          ext,
          options: [
            {
              text: newObj.DownloadWord[language],
              icon: IconDownload,
              onClick: async () => {
                const response = await downloadKewangan(tokens_session, {
                  filename: item.key,
                });
                const uint8Array = new Uint8Array(response.data);
                const blob = new Blob([uint8Array], {
                  type: `application/vnd.ms-excel`,
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('target', '_blank');
                a.setAttribute('download', item.key);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              },
            },
            {
              text: newObj.RenameWord[language],
              onClick: () => {
                setModalType('rename');
                setOpenModal(true);
                setSelected({
                  title: newObj.RenameWord[language],
                  onClose: () => setOpenModal(false),
                  onSubmit: async (name) => {
                    await updateKewangan(tokens_session, {
                      id: item.guid,
                      name,
                    });
                    await handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },
              icon: IconRename,
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this?',
                  onClose: () => setOpenModal(false),
                  onSubmit: async () => {
                    await deleteKewangan(tokens_session, {
                      id: item.id,
                    });
                    await handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },
              icon: IconDelete,
            },
          ],
          onClick: () => {
            // setModalType('finance');
            // setSelected({
            //   type: 'edit',
            //   id: item.id,
            //   name: item.name,
            //   description: item.description,
            //   status: item.status,
            // });
            // setOpenModal(true);
          },
        };
      default:
        return;
    }
  };
  const handleGetDataList = useCallback(
    async (tokens_session, payload) => {
      let response = null;
      switch (type) {
        case 'programKerja':
          response = await getProgramKerjaList(tokens_session, {
            tab: payload.q ? 'all' : payload.tab,
            q: payload.q,
          });
          break;
        case 'pengesyoranBaja':
          response = await getSyorList(tokens_session, payload);
          break;
        case 'atd':
          response = await getAtdList(tokens_session, {
            q: payload.q,
          });
          break;
        case 'pppls':
          response = await getPPPLSList(tokens_session, payload);
          break;
        case 'applicationAuthorization':
          response = await getApplicationAuthorizationList(
            tokens_session,
            payload
          );
          break;
        case 'participantAndLot':
          response = await getPesertaDanLotList(tokens_session, payload);
          break;
        case 'finance':
          response = await getKewanganList(tokens_session, payload);
          break;
        default:
          break;
      }
      const {data} = response;
      setUserAccessList(data.data || []);
    },
    [type, payload, tokens_session]
  );
  const handleShowListData = (type) => {
    switch (type) {
      case 'pengesyoranBaja':
      case 'atd':
      case 'pppls':
      case 'participantAndLot':
      case 'finance':
        return userAccessList.map((item) => (
          <UploadDataCenterCard {...uploadDataCenterCardProps(type, item)} />
        ));
      case 'programKerja':
        return userAccessList.map((item) => (
          <ProgramKerjaCard {...uploadDataCenterCardProps(type, item)} />
        ));
      case 'applicationAuthorization':
        return userAccessList.map((item) => (
          <UserAccessCard {...uploadDataCenterCardProps(type, item)} />
        ));
      default:
        return;
    }
  };
  const pageNavProps = (type) => {
    switch (type) {
      case 'programKerja':
        return {
          title: newObj.ProgramKerjaWord[language],
          href: '/adminpage',
        };
      case 'pengesyoranBaja':
        return {
          title: newObj.FertilizerTrackingWord[language],
          href: '/adminpage',
        };
      case 'atd':
        return {
          title: newObj.ATDWord[language],
          href: '/adminpage',
        };
      case 'pppls':
        return {
          title: newObj.PPPLSDataWord[language],
          href: '/adminpage',
        };
      case 'applicationAuthorization':
        return {
          title: newObj.PengesahanAplikasiWord[language],
          href: '/adminpage',
        };
      case 'participantAndLot':
        return {
          title: newObj.ParticipantsAndLotWord[language],
          href: '/adminpage',
        };
      case 'finance':
        return {
          title: newObj.FinanceWord[language],
          href: '/adminpage',
        };
      default:
        return;
    }
  };
  useEffect(() => {
    handleGetDataList(tokens_session, payload);
  }, [tokens_session, payload.tab]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundImage: `url(${macWP})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light'
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: isXsScreen || isSmScreen ? '10px' : '20px',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <PageNav {...pageNavProps(type)} />
        <Box className='userlist_ctr'>
          <Box className='userlist_box'>
            <Box className='userlist_head'>
              <Box className='left'>
                <Box className='tab_ctr'>
                  {tabList.map((tab, index) => (
                    <button
                      key={tab.value + index}
                      className={`tab ${
                        payload.tab === tab.value ? 'active' : ''
                      }`}
                      onClick={() =>
                        setPayload((prev) => ({...prev, tab: tab.value}))
                      }
                    >
                      {tab.label}
                    </button>
                  ))}
                </Box>
              </Box>
              <Box className='right'>
                <form
                  className='search_input_ctr'
                  onSubmit={(e) => {
                    e.preventDefault();

                    handleGetDataList(tokens_session, payload);
                  }}
                  action='POST'
                >
                  <input
                    type='text'
                    name='q'
                    onChange={(e) =>
                      setPayload((prev) => ({...prev, q: e.target.value}))
                    }
                    className='search_input'
                  />
                  <Search className='search_icon' />
                </form>

                <button
                  className='add_new_btn'
                  onClick={() => handleAddButton(type)}
                >
                  <img src={AddCircleIcon} alt='icon' />
                  {addButtonText(type)}
                </button>
              </Box>
            </Box>
            <Box className='userlist_card_ctr'>{handleShowListData(type)}</Box>
          </Box>
        </Box>
      </Box>
      {openModal && (
        <ModalFlexible
          type={modalType}
          data={{selected}}
          onClose={() => {
            handleGetDataList(tokens_session, payload);
            setOpenModal(false);
            setSelected(null);
          }}
        />
      )}
    </ThemeProvider>
  );
}
